"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeOrHomeSearchForOfferType = exports.FinancingTermsType = exports.HomePurchaseCreditType = exports.CalculationMethod = exports.HomePurchaseFeeFinancingOptionType = exports.HOME_PURCHASE_FEE_SURFACED_NAME_BY_FEE_TYPE = exports.HomePurchaseFeeType = exports.FeeRecipient = void 0;
/**
 * The party the money ultimately reaches. `borrower` and `seller` appear because the
 * settlement statement also carries credits and buyer/seller prorations, where the
 * "recipient" is the counterparty being credited rather than a vendor being paid.
 * @TranslateToPython
 */
var FeeRecipient;
(function (FeeRecipient) {
    FeeRecipient["appraiser"] = "appraiser";
    // broker = 'broker',
    FeeRecipient["borrower"] = "borrower";
    FeeRecipient["buyerAttorney"] = "buyerAttorney";
    FeeRecipient["buyerRealEstateAgent"] = "buyerRealEstateAgent";
    /** The recorder's office, for per-instrument recording charges and transfer taxes. */
    FeeRecipient["county"] = "county";
    /** The HOA itself or the management company acting for it. */
    FeeRecipient["hoa"] = "hoa";
    FeeRecipient["homeWarrantyCompany"] = "homeWarrantyCompany";
    /** Pest and general home inspectors. */
    FeeRecipient["inspector"] = "inspector";
    /** The hazard/homeowners carrier. Title carriers are titleInsuranceCompany. */
    FeeRecipient["insuranceCompany"] = "insuranceCompany";
    /** Aven, as the originating lender. */
    FeeRecipient["lender"] = "lender";
    /** The existing lienholder being paid off out of the settlement. */
    FeeRecipient["payoffLienholder"] = "payoffLienholder";
    FeeRecipient["seller"] = "seller";
    FeeRecipient["sellerAttorney"] = "sellerAttorney";
    FeeRecipient["sellerRealEstateAgent"] = "sellerRealEstateAgent";
    /** Holder of the escrow/impound account funded at closing. */
    FeeRecipient["servicer"] = "servicer";
    FeeRecipient["settlementAgent"] = "settlementAgent";
    FeeRecipient["surveyor"] = "surveyor";
    /** A city, town, county, or school district collecting an assessment. */
    FeeRecipient["taxingAuthority"] = "taxingAuthority";
    /** Per-transaction vendors: credit report, flood, and tax service providers. */
    FeeRecipient["thirdPartyVendor"] = "thirdPartyVendor";
    FeeRecipient["titleInsuranceCompany"] = "titleInsuranceCompany";
})(FeeRecipient || (exports.FeeRecipient = FeeRecipient = {}));
/**
 * Every line item a home purchase can carry, in the order ALTA prints them. Ops
 * transcribes one of these per row off a settlement statement, and an offer quotes the
 * subset it can price. Not all of them are fees in the strict sense - credits,
 * prorations, and payoffs share the vocabulary because they share the statement.
 * @TranslateToPython
 */
var HomePurchaseFeeType;
(function (HomePurchaseFeeType) {
    HomePurchaseFeeType["estimatedPreHomeNonLenderClosingCost"] = "estimatedPreHomeNonLenderClosingCost";
    HomePurchaseFeeType["personalProperty"] = "personalProperty";
    HomePurchaseFeeType["existingLoansAssumed"] = "existingLoansAssumed";
    HomePurchaseFeeType["financialSellerCredit"] = "financialSellerCredit";
    HomePurchaseFeeType["baseSellerCredit"] = "baseSellerCredit";
    HomePurchaseFeeType["excessSellerCredit"] = "excessSellerCredit";
    HomePurchaseFeeType["excessDeposit"] = "excessDeposit";
    HomePurchaseFeeType["propertyTaxProration"] = "propertyTaxProration";
    HomePurchaseFeeType["schoolTaxProration"] = "schoolTaxProration";
    HomePurchaseFeeType["hoaDuesProration"] = "hoaDuesProration";
    HomePurchaseFeeType["prorationsSellerCredit"] = "prorationsSellerCredit";
    // Aven charges a single up-front lender fee (2.5% of purchase price) in place of itemized points,
    // application, origination, underwriting and mortgage insurance rows.
    HomePurchaseFeeType["lenderFee"] = "lenderFee";
    HomePurchaseFeeType["prepaidInterest"] = "prepaidInterest";
    HomePurchaseFeeType["appraisal"] = "appraisal";
    HomePurchaseFeeType["creditReport"] = "creditReport";
    HomePurchaseFeeType["floodDetermination"] = "floodDetermination";
    HomePurchaseFeeType["floodMonitoring"] = "floodMonitoring";
    HomePurchaseFeeType["taxMonitoring"] = "taxMonitoring";
    HomePurchaseFeeType["taxStatusResearch"] = "taxStatusResearch";
    HomePurchaseFeeType["impoundsHomeownersInsurance"] = "impoundsHomeownersInsurance";
    HomePurchaseFeeType["impoundsMortgageInsurance"] = "impoundsMortgageInsurance";
    HomePurchaseFeeType["impoundsCityTownTaxes"] = "impoundsCityTownTaxes";
    HomePurchaseFeeType["impoundsCountyTaxes"] = "impoundsCountyTaxes";
    HomePurchaseFeeType["impoundsSchoolTaxes"] = "impoundsSchoolTaxes";
    HomePurchaseFeeType["aggregateAdjustment"] = "aggregateAdjustment";
    HomePurchaseFeeType["ownersTitleInsurance"] = "ownersTitleInsurance";
    HomePurchaseFeeType["loanPolicyTitleInsurance"] = "loanPolicyTitleInsurance";
    HomePurchaseFeeType["titleSearchFee"] = "titleSearchFee";
    HomePurchaseFeeType["insuranceBinder"] = "insuranceBinder";
    HomePurchaseFeeType["escrowFee"] = "escrowFee";
    HomePurchaseFeeType["notary"] = "notary";
    HomePurchaseFeeType["signing"] = "signing";
    HomePurchaseFeeType["buyerAgentCommission"] = "buyerAgentCommission";
    HomePurchaseFeeType["sellerAgentCommission"] = "sellerAgentCommission";
    // The county charges a separate recording fee per instrument, so the deed and the mortgage/deed of
    // trust are billed independently.
    HomePurchaseFeeType["recordingDeedFee"] = "recordingDeedFee";
    HomePurchaseFeeType["recordingMortgageFee"] = "recordingMortgageFee";
    HomePurchaseFeeType["recordingOther"] = "recordingOther";
    HomePurchaseFeeType["transferTaxes"] = "transferTaxes";
    HomePurchaseFeeType["pestInspection"] = "pestInspection";
    HomePurchaseFeeType["payoffPrincipalBalance"] = "payoffPrincipalBalance";
    HomePurchaseFeeType["payoffInterest"] = "payoffInterest";
    HomePurchaseFeeType["payoffAdditionalFees"] = "payoffAdditionalFees";
    HomePurchaseFeeType["survey"] = "survey";
    HomePurchaseFeeType["homeownersInsurancePremium"] = "homeownersInsurancePremium";
    HomePurchaseFeeType["homeInspection"] = "homeInspection";
    HomePurchaseFeeType["homeWarranty"] = "homeWarranty";
    HomePurchaseFeeType["miscellaneousHoaDues"] = "miscellaneousHoaDues";
    HomePurchaseFeeType["transferFeeToManagementCo"] = "transferFeeToManagementCo";
    // ALTA prints a catch-all "Assessments" charge alongside the itemized assessment rows below it, so
    // the settlement statement can carry an assessment the taxing authority did not break out by kind.
    HomePurchaseFeeType["assessments"] = "assessments";
    HomePurchaseFeeType["assessmentsSchoolTaxes"] = "assessmentsSchoolTaxes";
    HomePurchaseFeeType["assessmentsCityTownTaxes"] = "assessmentsCityTownTaxes";
    HomePurchaseFeeType["assessmentsCountyPropertyTaxes"] = "assessmentsCountyPropertyTaxes";
    HomePurchaseFeeType["buyerAttorney"] = "buyerAttorney";
    HomePurchaseFeeType["sellerAttorney"] = "sellerAttorney";
    HomePurchaseFeeType["custom"] = "custom";
    HomePurchaseFeeType["propertyInsurance"] = "propertyInsurance";
    HomePurchaseFeeType["titleLoanClosingFee"] = "titleLoanClosingFee";
    HomePurchaseFeeType["titleSettlementOrClosingFee"] = "titleSettlementOrClosingFee";
    HomePurchaseFeeType["titleFilingFee"] = "titleFilingFee";
    HomePurchaseFeeType["cplFees"] = "cplFees";
    HomePurchaseFeeType["depositOther"] = "depositOther";
})(HomePurchaseFeeType || (exports.HomePurchaseFeeType = HomePurchaseFeeType = {}));
exports.HOME_PURCHASE_FEE_SURFACED_NAME_BY_FEE_TYPE = {
    [HomePurchaseFeeType.estimatedPreHomeNonLenderClosingCost]: 'Estimated Pre-Home Non-Lender Closing Cost',
    [HomePurchaseFeeType.personalProperty]: 'Personal Property',
    [HomePurchaseFeeType.existingLoansAssumed]: 'Existing Loan(s) Assumed or Taken Subject to',
    [HomePurchaseFeeType.financialSellerCredit]: 'Financial Seller Credit',
    [HomePurchaseFeeType.excessDeposit]: 'Excess Deposit',
    [HomePurchaseFeeType.propertyTaxProration]: 'County Taxes',
    [HomePurchaseFeeType.schoolTaxProration]: 'School Taxes',
    [HomePurchaseFeeType.hoaDuesProration]: 'HOA Dues',
    [HomePurchaseFeeType.prorationsSellerCredit]: 'Seller Proration Contribution',
    [HomePurchaseFeeType.lenderFee]: 'Origination / Lender Fees',
    [HomePurchaseFeeType.appraisal]: 'Appraisal Fee',
    [HomePurchaseFeeType.creditReport]: 'Credit Report Fee',
    [HomePurchaseFeeType.floodDetermination]: 'Flood Determination Fee',
    [HomePurchaseFeeType.floodMonitoring]: 'Flood Monitoring Fee',
    [HomePurchaseFeeType.taxMonitoring]: 'Tax Monitoring Fee',
    [HomePurchaseFeeType.taxStatusResearch]: 'Tax Status Research Fee',
    [HomePurchaseFeeType.ownersTitleInsurance]: "Owner's Title Insurance",
    [HomePurchaseFeeType.loanPolicyTitleInsurance]: 'Loan Policy of Title Insurance',
    [HomePurchaseFeeType.titleSearchFee]: 'Title Search / Title Fees',
    [HomePurchaseFeeType.insuranceBinder]: 'Insurance Binder',
    [HomePurchaseFeeType.escrowFee]: 'Escrow / Settlement Fee',
    [HomePurchaseFeeType.notary]: 'Notary Fee',
    [HomePurchaseFeeType.signing]: 'Signing Fee',
    [HomePurchaseFeeType.titleLoanClosingFee]: 'Title - Loan Closing Fee',
    [HomePurchaseFeeType.titleSettlementOrClosingFee]: 'Title - Settlement or Closing Fee',
    [HomePurchaseFeeType.titleFilingFee]: 'Title - Filing Fee',
    [HomePurchaseFeeType.cplFees]: 'CPL Fees',
    [HomePurchaseFeeType.recordingDeedFee]: 'Recording Fee - Deed',
    [HomePurchaseFeeType.recordingMortgageFee]: 'Recording Fee - Mortgage / Deed of Trust',
    [HomePurchaseFeeType.recordingOther]: 'Recording Fee - Other',
    [HomePurchaseFeeType.transferTaxes]: 'Transfer Tax',
    [HomePurchaseFeeType.assessments]: 'Assessments',
    [HomePurchaseFeeType.assessmentsSchoolTaxes]: 'Assessments - School Taxes',
    [HomePurchaseFeeType.assessmentsCityTownTaxes]: 'Assessments - City / Town Taxes',
    [HomePurchaseFeeType.assessmentsCountyPropertyTaxes]: 'Assessments - County Property Taxes',
    [HomePurchaseFeeType.payoffPrincipalBalance]: 'Seller Existing Liens to Pay Off',
    [HomePurchaseFeeType.payoffInterest]: 'Payoff Interest',
    [HomePurchaseFeeType.payoffAdditionalFees]: 'Payoff Additional Fees',
    [HomePurchaseFeeType.prepaidInterest]: 'Prepaid Interest',
    [HomePurchaseFeeType.impoundsHomeownersInsurance]: 'Homeowners Insurance Impound',
    [HomePurchaseFeeType.impoundsMortgageInsurance]: 'Mortgage Insurance Impound',
    [HomePurchaseFeeType.impoundsCityTownTaxes]: 'City / Town Tax Impound',
    [HomePurchaseFeeType.impoundsCountyTaxes]: 'County Tax Impound',
    [HomePurchaseFeeType.impoundsSchoolTaxes]: 'School Tax Impound',
    [HomePurchaseFeeType.aggregateAdjustment]: 'Aggregate Adjustment',
    [HomePurchaseFeeType.homeownersInsurancePremium]: "Homeowner's Insurance Premium",
    [HomePurchaseFeeType.propertyInsurance]: 'Property Insurance',
    [HomePurchaseFeeType.pestInspection]: 'Pest Inspection Fee',
    [HomePurchaseFeeType.survey]: 'Survey Fee',
    [HomePurchaseFeeType.homeInspection]: 'Home Inspection Fee',
    [HomePurchaseFeeType.homeWarranty]: 'Home Warranty Fee',
    [HomePurchaseFeeType.miscellaneousHoaDues]: 'HOA Dues',
    [HomePurchaseFeeType.transferFeeToManagementCo]: 'Transfer Fee to Management Co.',
    [HomePurchaseFeeType.buyerAttorney]: 'Buyer Attorney Fees',
    [HomePurchaseFeeType.sellerAttorney]: 'Seller Attorney Fees',
    [HomePurchaseFeeType.buyerAgentCommission]: "Real Estate Commission — Buyer's Agent",
    [HomePurchaseFeeType.sellerAgentCommission]: "Real Estate Commission — Seller's Agent",
    [HomePurchaseFeeType.depositOther]: 'Other Deposit',
    [HomePurchaseFeeType.baseSellerCredit]: 'Base Seller Credit',
    [HomePurchaseFeeType.excessSellerCredit]: 'Excess Seller Credit',
};
/** The settlement treatment carried by a home-purchase fee term. */
// @TranslateToPython @TranslateToSerializableObject
var HomePurchaseFeeFinancingOptionType;
(function (HomePurchaseFeeFinancingOptionType) {
    HomePurchaseFeeFinancingOptionType["borrowerPaidAtClosing"] = "borrowerPaidAtClosing";
    HomePurchaseFeeFinancingOptionType["borrowerPaidBeforeClosing"] = "borrowerPaidBeforeClosing";
    HomePurchaseFeeFinancingOptionType["sellerPaidAtClosing"] = "sellerPaidAtClosing";
    HomePurchaseFeeFinancingOptionType["sellerPaidBeforeClosing"] = "sellerPaidBeforeClosing";
    HomePurchaseFeeFinancingOptionType["lenderPaidBeforeClosingAbsorbed"] = "lenderPaidBeforeClosingAbsorbed";
    HomePurchaseFeeFinancingOptionType["lenderPaidAtClosingAbsorbed"] = "lenderPaidAtClosingAbsorbed";
    HomePurchaseFeeFinancingOptionType["lenderPaidAtClosingFinancedForBorrower"] = "lenderPaidAtClosingFinancedForBorrower";
})(HomePurchaseFeeFinancingOptionType || (exports.HomePurchaseFeeFinancingOptionType = HomePurchaseFeeFinancingOptionType = {}));
// @TranslateToPython
var CalculationMethod;
(function (CalculationMethod) {
    /** The Purchase Price less the Down Payment is the AvenPurchaseShare.  It is NOT the Purchase Price less (Down Payment and costs paid up front) */
    CalculationMethod["fractionOfAvenPurchaseShare"] = "fractionOfAvenPurchaseShare";
    CalculationMethod["fractionOfLineSize"] = "fractionOfLineSize";
    CalculationMethod["fractionOfPurchasePrice"] = "fractionOfPurchasePrice";
    CalculationMethod["fixedAmount"] = "fixedAmount";
})(CalculationMethod || (exports.CalculationMethod = CalculationMethod = {}));
/**
 * A credit reduces what the borrower must bring to a purchase (money in), as opposed to a fee
 * (money out). Credits are disclosed separately from feeTerms because they carry neither a
 * recipient - a credit always accrues to the borrower - nor a financing option - a credit is not
 * financed, it offsets the amount that must be. Only sellerCredit exists today.
 * @TranslateToPython
 */
var HomePurchaseCreditType;
(function (HomePurchaseCreditType) {
    HomePurchaseCreditType["sellerCredit"] = "sellerCredit";
})(HomePurchaseCreditType || (exports.HomePurchaseCreditType = HomePurchaseCreditType = {}));
/**
 * Discriminates the members of the FinancingTerms union. Today there is only AvenSimpleLoan
 * (a fixed-rate installment loan); the tag exists so callers can switch on it exhaustively and so
 * a second member (e.g. revolving) can be added without silently changing the wire shape.
 * @TranslateToPython
 */
var FinancingTermsType;
(function (FinancingTermsType) {
    FinancingTermsType["avenSimpleLoan"] = "avenSimpleLoan";
})(FinancingTermsType || (exports.FinancingTermsType = FinancingTermsType = {}));
/** @TranslateToPython */
var HomeOrHomeSearchForOfferType;
(function (HomeOrHomeSearchForOfferType) {
    HomeOrHomeSearchForOfferType["Home"] = "home";
    HomeOrHomeSearchForOfferType["HomeSearch"] = "homeSearch";
})(HomeOrHomeSearchForOfferType || (exports.HomeOrHomeSearchForOfferType = HomeOrHomeSearchForOfferType = {}));
